/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/3
 * @updateTime 2021/9/3
 * @decription 申请复议-上传材料相关处理js
 * @namespace 【sccl】
 */
// 文件上传组件
import acUploadFile from '@/components/app/upload-file/index.vue';
export default {
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        acUploadFile
    },
    // 数据
    data() {
        return {
            // 上传材料数据
            scclData: {},
            // 上传材料url
            scclUploadUrl: 'ssbq/api/fy/fyxx/fileupload',
            // 删除材料url
            scclDeleteUrl: 'ssbq/api/fy/fysccl/delsccl',
            // 上传材料是否加载完成
            scclLoaded: false
        };
    },
    computed: {
        // 删除材料接口参数
        scclDeleteParam() {
            return {
                // 复议id
                fyid: this.fyid
            };
        }
    },
    // 方法
    methods: {

        /**
         * 人员id
         * @param {String} ryid 人员id
         * @returns {void}
         * */
        scclSfzmlUploadParam(ryid) {
            /**
             * 返回方法动态获取
             * @param {BinaryType} file 文件流
             * @param {String} cId 文件id
             * @param {FormData} 表单数据
             * @returns {Object} 对象
             * */
            return (file, cId, formData) => {
                // 组件默认会塞入file，此处参数名是files
                formData.delete('file');
                return {
                    // 人员id
                    id: ryid,
                    // 文件二进制流
                    files: file,
                    // 复议id
                    fyid: this.fyid,
                    // 材料类型
                    cllx: 2
                }
            }
        },

        /**
         * 获取上传材料参数
         * @param {Number} cllx
         * @returns {Function}
         * */
        scclUploadParam(cllx) {
            /**
             * 返回方法动态获取
             * @param {BinaryType} file 文件流
             * @param {String} cId 文件id
             * @param {FormData} 表单数据
             * @returns {Object} 对象
             * */
            return (file, cId, formData) => {
                // 组件默认会塞入file，此处参数名是files
                formData.delete('file');
                return {
                    files: file,
                    // 复议id
                    fyid: this.fyid,
                    // 材料类型
                    cllx: cllx
                }
            }
        },

        /**
         * 获取上传材料数据
         * @returns {void}
         * */
        scclGetData() {
            this.requestFySCCL({
                // 复议id
                fyid: this.fyid
            }).then((res) => {
                // 赋值上传材料数据
                this.scclData = res.data;
                // 上传材料加载完成
                this.scclLoaded = true;
                // 上传材料同步申请人数据
                this.bqid && this.scclSyncSqrData();
                // 上传材料同步代理人数据
                this.bqid && this.scclSyncDlrData();
            })
        },

        /**
         * 获取上传文件数据
         * @param {Object} resData 请求返回数据
         * @param {Object} fileData 上传组件对应数据
         * @returns {Object} 处理之后的上传文件
         * */
        scclGetUploadFileData(resData, fileData) {
            return {
                // 将返回数据与组件数据进行合并
                ...resData.tFySqcl,
                ...fileData
            };
        },

        /**
         * 通过人员id删除身份证明材料
         * @param {String} ryId 人员id
         * @returns {void}
         * */
        scclDelByRyId(ryId) {
            // 身份证明类材料
            const _fileList = this.scclData.sfzml;
            if (!_fileList.length) {
                return;
            }
            // 找到文件进行删除
            _fileList.some((fileItem, index) => {
                // 人员id一致，则进行数据删除
                if (ryId === fileItem.ryid) {
                    _fileList.splice(index, 1);
                    return true;
                }
                return false;
            });
        },

        /**
         * 通过人员id同步对应的人员名称
         * @param {String} ryId 人员id
         * @param {String} ryMc 人员名称
         * @param {Boolean} sqrFlag 是否是申请人
         * @returns {void}
         * */
        scclSyncDataByRyId(ryId, ryMc, sqrFlag = false) {
            // 身份证明类材料
            const _fileList = this.scclData.sfzml;
            // 找到文件进行名称修改
            const _flag = _fileList.some(fileItem => {
                // 人员id一致，则进行数据修改
                if (ryId === fileItem.ryid) {
                    fileItem.rymc = ryMc;
                    return true;
                }
                return false;
            });
            // 如果不存在对应的人员id记录，则需要进行添加
            if (!_flag) {
                _fileList[sqrFlag ? 'unshift' : 'push']({
                    // 人员id
                    ryid: ryId,
                    // 人员名称
                    rymc: ryMc,
                    // 材料列表
                    clList: []
                })
            }
        },

        /**
         * 上传材料同步申请人数据
         * @returns {void}
         * */
        scclSyncSqrData() {
            // 如果上传材料请求或者申请人请求未加载完成，则直接退出
            if (!this.scclLoaded || !this.sqrLoaded) {
                return;
            }
            // 遍历申请人列表，同步申请人信息
            this.sqrDataList.forEach((sqrItem) => {
                this.scclSyncDataByRyId(sqrItem.cId, this.sqrGetName(sqrItem) + '-' + sqrItem.cSqrlxText);
            });
        },

        /**
         * 上传材料同步代理人数据
         * @returns {void}
         * */
        scclSyncDlrData() {
            // 如果上传材料请求或者代理人请求未加载完成，则直接退出
            if (!this.scclLoaded || !this.dlrLoaded) {
                return;
            }
            // 遍历代理人列表，同步代理人信息
            this.dlrDataList.forEach((dlrItem) => {
                this.scclSyncDataByRyId(dlrItem.cId, dlrItem.cDlrxm + '-代理人');
            });
        }
    }
};
